export default {
	updateAbbreviationSetups(state, payload) {
		state.AbbreviationSetups = payload;
	}
};
